import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { profile as profileService } from '@shared/api/services';
import {
	areSameStudentPreferences,
	clearStudentOnboardingPrefillSearch,
	getPersistedStudentOnboardingPrefillSearch,
	getStudentOnboardingPrefill,
} from './student-onboarding-prefill';

export const useApplyStudentOnboardingPrefill = (profile) => {
	const queryClient = useQueryClient();
	const appliedRef = useRef(false);

	useEffect(() => {
		if (!profile || appliedRef.current) return;

		const onboardingPrefill = getStudentOnboardingPrefill({
			search: window.location.search,
			persistedSearch: getPersistedStudentOnboardingPrefillSearch(),
		});

		if (!onboardingPrefill.hasRelevantParams) return;

		appliedRef.current = true;

		if (
			onboardingPrefill.hasCompleteStudentPreferences &&
			!areSameStudentPreferences(profile?.student_preferences, onboardingPrefill.studentPreferences)
		) {
			profileService.updateUserPreference({
				student_preferences: onboardingPrefill.studentPreferences,
			}).finally(() => {
				queryClient.invalidateQueries(['profile']);
				clearStudentOnboardingPrefillSearch();
			});
		} else {
			clearStudentOnboardingPrefillSearch();
		}
	}, [profile, queryClient]);
};
